import React, { useState, useEffect, useRef } from "react";
import DatosMovimientoAlmacen from "./DatosMovimientoAlmacenIngreso";
import { notificarError, notificarMsg } from "../Almacenes/AlmacenNotify";
import moment from "moment";
import { GastosSelector } from "./GastosSelector";
import { GUIA_REMISION, NOTA_INGRESO } from "../../Global";
import { OrdenesCompraSelector } from "./ComprasExternasSelector";
import { NotasEgresoSelector } from "./NotasEgresoSelector";
import ModalProveedor from "../clientes/ClienteModal";
import ProveedorNuevo from "../Proveedores/ProveedorNuevo";
import ProveedorSearch from "../Proveedores/ProveedoresListaSearch";

export default function RegistrarMovimientoAlmacen({ idAlmacen, onRegistroCompletado, onCancel }) {
    const [proveedor, setProveedor] = useState(null);
    const [linkedDocument, setLinkedDocument] = useState(null);
    const [gastos, setGastos] = useState([]);
    const [ordenesCompra, setOrdenesCompra] = useState([]);
    const [notasEgreso, setNotasEgreso] = useState([]);
    const [gastoSeleccionado, setGastoSeleccionado] = useState(null);
    const [ordenCompraSeleccionada, setOrdenCompraSeleccionada] = useState(null);
    const [notaEgresoSeleccionada, setNotaEgresoSeleccionada] = useState(null);
    const [modalProveedorIsOpen, setModalProveedorIsOpen] = useState(false);
    const [accionProveedor, setAccionProveedor] = useState(null);
    const [rucProveedor, setRucProveedor] = useState("");
    const [glosa, setGlosa] = useState("");
    const [confEmpresa, setConfEmpresa] = useState({
        deactivateValidationOnAmountOnMovAlmacen: false
    });
    const formProveedorRef = useRef({
        IdProveedor: null,
        Ruc: "",
        NomProveedor: "",
        NomContacto: ""
    });

    useEffect(() => {
        fetchGastos();
        fetchComprasExternas();
        fetchNotasEgreso();
        fetchConfEmpresa();
    }, []);

    const fetchConfEmpresa = async () => {
        const req = await fetch(`/api/config/emp`);
        const conf = await req.json();

        if (!('deactivateValidationOnAmountOnMovAlmacen' in conf)) {
            conf['deactivateValidationOnAmountOnMovAlmacen'] = false;
        };

        setConfEmpresa(conf);
    }

    const fetchGastos = async () => {
        const startDate = moment().subtract(3, 'days').format("YYYY-MM-DD");
        const endDate = moment(new Date()).format("YYYY-MM-DD");
    
        const response = await fetch(`/api/comprasexternas/items?almacen=${idAlmacen}&desde=${startDate}&hasta=${endDate}`);

        if (!response.ok) {
            notificarError("No se pudo obtener los gastos.");
            return;
        }

        const data = await response.json();

        setGastos(data.items);
    }

    const fetchComprasExternas = async () => {
        const response = await fetch(`/api/ordenescompra/list/allsuc/poratender`);

        if (!response.ok) {
            notificarError("No se pudo obtener las compras externas.");
            return;
        }

        const data = await response.json();

        setOrdenesCompra(data[1]);
    }

    const fetchNotasEgreso = async () => {
        const response = await fetch(`/api/movimientosalmacen/notas-egreso/list/allsuc/poratender`);

        if (!response.ok) {
            notificarError("No se pudo obtener las notas de egreso.");
            return;
        }

        const data = await response.json();

        setNotasEgreso(data);
    }

    const handleChangeProveedor = (proveedor) => {
        setProveedor(proveedor);
    }

    const handleClickNuevoProveedor = () => {
        setModalProveedorIsOpen(true);
        setAccionProveedor('NuevoProveedor');
    }

    const handleClickBuscarProveedor = () => {
        formProveedorRef.current = {
            IdProveedor: proveedor?.IdProveedor || null,
            Ruc: proveedor?.Ruc || "",
            NomProveedor: proveedor?.NombreComercial || "",
            NomContacto: ""
        };
        setModalProveedorIsOpen(true);
        setAccionProveedor('BuscarProveedor');
    }

    const handleCloseModalProv = () => {
        if (formProveedorRef.current.IdProveedor && formProveedorRef.current.Ruc) {
            const proveedorActualizado = {
                IdProveedor: formProveedorRef.current.IdProveedor,
                Ruc: formProveedorRef.current.Ruc,
                NombreComercial: formProveedorRef.current.NomProveedor,
                value: `${formProveedorRef.current.IdProveedor}-${formProveedorRef.current.Ruc}`,
                label: formProveedorRef.current.NomProveedor
            };
            setProveedor(proveedorActualizado);
        }
        setModalProveedorIsOpen(false);
    }

    const AsignarValorDoc = (dataProveedor) => {
        const nuevoProveedor = {
            IdProveedor: dataProveedor.IdProveedor,
            Ruc: dataProveedor.Ruc,
            NombreComercial: dataProveedor.RazonSocial,
            value: `${dataProveedor.IdProveedor}-${dataProveedor.Ruc}`,
            label: dataProveedor.RazonSocial
        };
        setProveedor(nuevoProveedor);
        setRucProveedor(dataProveedor.Ruc);
        formProveedorRef.current = {
            IdProveedor: dataProveedor.IdProveedor,
            Ruc: dataProveedor.Ruc,
            NomProveedor: dataProveedor.RazonSocial,
            NomContacto: dataProveedor.Contacto || ""
        };
    }

    const onChangeLinkedDocument = (linkedDocument) => {
        setLinkedDocument(linkedDocument);
    }

    const validateNotaIngreso = async () => {
        guardarMovimiento();
    }

    const validateGuiaRemision = async () => {
        const { serie, correlativo, fechaMovimiento } = linkedDocument;

        const serieValida = serie && serie.trim().length > 0;
        const correlativoValido = correlativo.trim() && /^\d+$/.test(correlativo);
        const fechaMovimientoValida = fechaMovimiento && moment(fechaMovimiento).isValid();

        if (!serieValida) {
            notificarError("La serie es requerida.");
            return;
        }

        if (!correlativoValido) {
            notificarError("El correlativo es requerido.");
            return;
        }

        if (!fechaMovimientoValida) {
            notificarError("La fecha de emisión es requerida.");
            return;
        }

        guardarMovimiento();
    }

    const validateComprobante = async () => {
        const { serie, correlativo, tipoDoc, total: montoImporteVenta, fechaMovimiento } = linkedDocument;

        const serieValida = serie && serie.trim().length > 0;
        const correlativoValido = correlativo.trim() && /^\d+$/.test(correlativo);
        const totalValido = montoImporteVenta && /^\d*\.?\d*$/.test(montoImporteVenta);
        const fechaMovimientoValida = fechaMovimiento && moment(fechaMovimiento).isValid();

        if (!serieValida) {
            notificarError("La serie es requerida.");
            return;
        }

        if (!correlativoValido) {
            notificarError("El correlativo es requerido.");
            return;
        }

        if (!confEmpresa.deactivateValidationOnAmountOnMovAlmacen && !totalValido) {
            notificarError("El monto es requerido.");
            return;
        }

        if (!fechaMovimientoValida) {
            notificarError("La fecha de emisión es requerida.");
            return;
        }

        try {
            const response = await fetch(`/api/movimientosalmacen/validar-comprobante`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify({
                    consultaComprobante: {
                        numDoc: proveedor.Ruc,
                        serie,
                        correlativo,
                        tipoDoc,
                        montoImporteVenta,
                        fechaEmision: fechaMovimiento,
                    },
                }),
            });

            if (response.status === 200) {
                notificarMsg("El comprobante es válido.");
                guardarMovimiento();
            } else {
                notificarError("El comprobante no es válido o hubo un error al validar.");
                if (window.confirm("¿Desea continuar de todas maneras?")) {
                    guardarMovimiento();
                }
            }
        } catch (error) {
            notificarError(error.message);
        }
    }

    const handleValidarComprobante = async () => {
        if (!proveedor) {
            notificarError("El campo proveedor es requerido.");
            return;
        }

        if (!linkedDocument) {
            notificarError("Se debe asociar un comprobante válido.");
            return;
        }
        
        const { tipoDoc } = linkedDocument;

        if (+tipoDoc === NOTA_INGRESO) {
            await validateNotaIngreso();
        } else if (+tipoDoc === GUIA_REMISION) {
            await validateGuiaRemision();
        } else {
            await validateComprobante();
        }
    }

    const handleSeleccionarGasto = (gasto) => {
        setGastoSeleccionado(gasto.IdCompraExterna);
    }

    const handleSeleccionarCompraExterna = (compraExterna) => {
        setOrdenCompraSeleccionada(compraExterna.IdOrdenCompra);
    }

    const handleSeleccionarNotaEgreso = (notaEgreso) => {
        setNotaEgresoSeleccionada(notaEgreso.IdMovimientoAlmacen);
    }

    const guardarMovimiento = async () => {
        const totalMovimiento = confEmpresa.deactivateValidationOnAmountOnMovAlmacen 
            ? 0 
            : +linkedDocument.total;
        
        const req = await fetch("/api/movimientosalmacen/add/", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                IdMovimientoAlmacen: 1,
                Numero: "",
                FechaRegistro: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                FechaMovimiento: moment(linkedDocument.fechaEmision).format("YYYY-MM-DD HH:mm"),
                IdAlmacen: idAlmacen,
                IdTipoDocumentoSunat: linkedDocument.tipoDoc,
                NroDocumentoSunat: `${linkedDocument.serie}-${linkedDocument.correlativo}`,
                DocInterno: "",
                IdOrdenCompra: ordenCompraSeleccionada,
                IdCompraExterna: gastoSeleccionado,
                IdNotaEgreso: notaEgresoSeleccionada,
                NroOrdenCompra: "",
                Estado: "Sin procesar",
                IdProveedor: proveedor.IdProveedor,
                tipoCambio: 0,
                idCce: null,
                idTipoMov: 1,
                total: totalMovimiento,
                Glosa: glosa,
            })
        });

        const rpta = await req.json();

        if (
            Array.isArray(rpta) &&
            rpta.length > 0 &&
            Array.isArray(rpta[0]) &&
            rpta[0].length > 0 &&
            Array.isArray(rpta[0][0]) &&
            rpta[0][0].length > 0 &&
            rpta[0][0][0].estado
        ) {
            const movimientoId = rpta[0][0][0].estado;
            onRegistroCompletado(+movimientoId)
        } else {
            notificarError("Error al registrar el movimiento.");
        }
    }

    return <div className="container-fluid" style={{ width: '100%' }}>
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-info-tab" data-toggle="tab" data-target="#nav-info" type="button" role="tab" aria-controls="nav-info" aria-selected="true">Datos de movimiento</button>
                <button class="nav-link text-muted" id="nav-items-tab" data-toggle="tab" data-target="#nav-items" type="button" role="tab" aria-controls="nav-items" aria-selected="false" disabled>Items</button>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab">
                <div className="row">
                    <div className="col-12">
                        <DatosMovimientoAlmacen
                            proveedor={proveedor}
                            handleChangeProveedor={handleChangeProveedor}
                            onChangeLinkedDocument={onChangeLinkedDocument}
                            handleClickNuevoProveedor={handleClickNuevoProveedor}
                            handleClickBuscarProveedor={handleClickBuscarProveedor}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Asociar con orden de compra</label>
                        <OrdenesCompraSelector options={ordenesCompra} onSeleccionChange={handleSeleccionarCompraExterna} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Asociar con nota de egreso</label>
                        <NotasEgresoSelector options={notasEgreso} onSeleccionChange={handleSeleccionarNotaEgreso} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Asociar con gasto de flete</label>
                        <GastosSelector options={gastos} onSeleccionChange={handleSeleccionarGasto} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Glosa</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={glosa}
                            onChange={(e) => setGlosa(e.target.value)}
                            placeholder="Ingrese observaciones"
                        />
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="nav-items" role="tabpanel" aria-labelledby="nav-items-tab">
            </div>
        </div>

        <div className="d-flex justify-content-between">
            <button type="button" className="btn btn-danger" onClick={onCancel}>Cancelar</button>
            <button type="button" className="btn btn-info" onClick={handleValidarComprobante}>Validar movimiento</button>
        </div>

        {
            accionProveedor === 'NuevoProveedor' ?
                <ModalProveedor 
                    isOpen={modalProveedorIsOpen}
                    onClose={handleCloseModalProv}
                    title="NUEVO PROVEEDOR"
                >
                    <ProveedorNuevo
                        onClose={handleCloseModalProv}
                        NumeroDocumento={rucProveedor}
                        AsignarValorDoc={AsignarValorDoc}
                        sw='oc_nuevo'
                    />
                </ModalProveedor> :
                <ModalProveedor 
                    isOpen={modalProveedorIsOpen}
                    onClose={handleCloseModalProv}
                    title="BUSCAR PROVEEDOR"
                >
                    <ProveedorSearch
                        onClose={handleCloseModalProv}
                        form={formProveedorRef.current}
                    />
                </ModalProveedor>
        }
    </div>
}